<acabim-datatable #projectsTable [dataSources]="projectDataSources" [hasDetailView]="true">
</acabim-datatable>
<ng-template [ngIf]="projectDataSources[0].showDetails">
    <acabim-modal [display]="true" [title]="'Project Details'" fixHeight="80vh" (status)="toggleBuildingDetailStatus($event)">
        <acabim-admin-project-details [project]="projectDataSources[0].detailData"
        ></acabim-admin-project-details>
    </acabim-modal>
</ng-template>
